<div class="delete-popup-container delete-test-popup-wrapper delete-wordings-popup-wrapper"
	*ngIf="!isMinimumTestingStd">
	<div class="content">
		<img *ngIf="!undoModelCode" src="assets/images/new-set/delete-primary.svg" alt="">
		<span *ngIf="undoModelCode" style="color: cornflowerblue"> <i class="fa fa-undo"></i></span>
		<div class="title-container">
			<h3>{{ 'CARE_WORDINGS.LBL_DELETE_WORDINGS' | translate }} {{this.modelRemove.name}} ?</h3>
			<p>{{'CONFIRM_DELETE_POPUP.LBL_MSG'| translate}}<span> {{this.modelRemove.moduleName}}
				</span></p>
		</div>
		<!-- <div class="title-container" *ngIf="undoModelCode">
			<h3>{{ 'CARE_WORDINGS.LBL_UNDO' | translate }} {{this.modelRemove.name}} ?</h3>
			<p>{{'CONFIRM_DELETE_POPUP.LBL_UNDO'| translate}}<span> {{this.modelRemove.moduleName}}
				</span></p>
		</div> -->
	</div>
	<div class="text-right">
		<button class="secondary-cta link btn-capitlize" (click)="onCancel()">{{ 'STAFF_SUMMARY.LBL_CONFIRMCANCEL' |
			translate
			}}</button>
		<button class="primary-cta btn-capitlize" (click)="onDelete()">{{
			'STAFF_SUMMARY.LBL_DELETE' | translate
			}}</button>
		<!-- <button *ngIf="undoModelCode" class="primary-cta btn-capitlize"
			(click)="onDelete()">{{'CONFIRM_DELETE_POPUP.LBL_UNDO_BTN' | translate}}</button> -->
	</div>
</div>
<div class="delete-popup-container delete-test-popup-wrapper delete-wordings-popup-wrapper" *ngIf="isMinimumTestingStd">
	<div class="content">
		<img *ngIf="!undoModelCode" src="assets/images/new-set/delete-primary.svg" alt="">
		<span *ngIf="undoModelCode" style="color: cornflowerblue"> <i class="fa fa-undo"></i></span>
		<div class="title-container">
			<h3>{{this.modelRemove.name}} ?</h3>
			<p>Are you sure you want to remove the test <span> {{this.modelRemove.moduleName}}
				</span> from minimum test standard</p>
		</div>
		<!-- <div class="title-container" *ngIf="undoModelCode">
			<h3>{{ 'CARE_WORDINGS.LBL_UNDO' | translate }} {{this.modelRemove.name}} ?</h3>
			<p>{{'CONFIRM_DELETE_POPUP.LBL_UNDO'| translate}}<span> {{this.modelRemove.moduleName}}
				</span></p>
		</div> -->
	</div>
	<div class="text-right">
		<button class="secondary-cta link btn-capitlize" (click)="onCancel()">{{ 'STAFF_SUMMARY.LBL_CONFIRMCANCEL' |
			translate
			}}</button>
		<button class="primary-cta btn-capitlize" (click)="onDelete()">{{
			'STAFF_SUMMARY.LBL_DELETE' | translate
			}}</button>
		<!-- <button *ngIf="undoModelCode" class="primary-cta btn-capitlize"
			(click)="onDelete()">{{'CONFIRM_DELETE_POPUP.LBL_UNDO_BTN' | translate}}</button> -->
	</div>
</div>